import "./Reviews.module.css";
import Header from "@/reusable_sections/Header";
import Testimonials from "./sections/Testimonials";
import Googlereviewscta from "./sections/Googlereviewscta";
import Footer from "@/reusable_sections/Footer";
export default function ReviewsPage() {
  return <div>
      <Header />
      <Testimonials />
      <Googlereviewscta />
      <Footer />
    </div>;
}